import React, { memo, useState } from 'react';
import { List } from 'antd';
import intl from 'react-intl-universal';
import { IconFont, Avatar } from '@/components';
import { IOkrAlignMapItem } from '@/api/okr';
import GridList from '../grid-list'; // 第二列以后 list
import OKRStatusItem from '../okr-status-item';
import OKRPopover from '../popover';

interface IProps {
  dataSource: IOkrAlignMapItem[];
  name: string;
  headerType: string;
  isMy: boolean;
  onSelectUser: (user: any, option: any) => void;
}

const Basic = (props: IProps) => {
  const [currentClickId, setCurrentClickId] = useState<number>();

  const { dataSource, name, headerType, onSelectUser, isMy } = props;

  const isUser = headerType === intl.get('user').d('人员');
  const isVirDept = headerType === intl.get('virtual').d('虚拟');
  const isDept = headerType === intl.get('department').d('部门');

  const reRender = (id?: number) => {
    setCurrentClickId(id);
  };

  const header = (
    <div className="u-header">
      {isUser && (
        <Avatar imgPath={dataSource?.[0]?.photoUrl} userName={name} className="avatar-32" />
      )}
      {isDept && <IconFont type="icon-zuzhi1" className="dept-logo" />}
      {isVirDept && <IconFont type="icon-zuzhi2" className="dept-logo" />}
      <span style={{ marginLeft: '16px' }}>
        {isMy ? intl.get('okr.my').d('我的OKR') : intl.get('okr.owner.who', { name })}
      </span>
    </div>
  );

  return (
    <List
      className="u-relative-main"
      header={header}
      itemLayout="horizontal"
      dataSource={dataSource}
      renderItem={(item) => {
        const { id, objectivesName, summaryStatus } = item;
        return (
          <List.Item
            actions={[
              <GridList
                {...(item as any)}
                onSelectUser={onSelectUser}
                currentClickId={currentClickId!}
                reRender={reRender}
                parentIdList={[id]}
              />,
            ]}
          >
            <OKRPopover info={item}>
              <div>
                <OKRStatusItem
                  {...item}
                  objectivesName={objectivesName}
                  okrId={id}
                  summaryStatus={summaryStatus}
                />
              </div>
            </OKRPopover>
          </List.Item>
        );
      }}
    />
  );
};

export default memo(Basic);
